<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <el-form :rules="rules"  ref="form" size="mini" :model="form" label-width="100px">
        <el-form-item  label="工号">
          <el-input v-model="form.sn" autocomplete="off" placeholder="请输入工号"></el-input>
        </el-form-item>
        <el-form-item  label="用户名" prop="user_name">
          <el-input v-model="form.user_name" autocomplete="off" placeholder="请输入用户名8位数字、字母不分大小写"></el-input>
        </el-form-item>
        <el-form-item  label="密码" v-if="form.id==''">
          <el-input v-model="form.pass"  placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item  label="确认密码" v-if="form.id==''">
          <el-input v-model="form.repass" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item  label="角色名称">
          <el-select
                  disabled
                  v-model="form.role_id"
                  placeholder="请选择角色名称"
                  @change="changeRoleNameValue($event)"
          >
            <el-option v-for="item in roleNameData"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="状态">
          <el-select
                  v-model="form.status"
                  placeholder="请选择状态"
          >
            <el-option label="开启" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
  import moment from "moment";
  import {hexMD5} from "@/utils/md5";
  export default {
    name:'eShopUserForm',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    components: { },
    data(){
      return {
        roleNameData: [],
        localVisible:false,
        rankList:[],
        shopInfo:null,
        form:{
          sn:'',
          user_name:'',
          pass:'',
          repass:'',
          id:'',
          shop_id:'',
          status:0,
          role_id:'',

          realname:'',
          nickname:'',
          user_rank:'',
          sku_id:'',
          batch:'',
          price:0,
          name:'',
          num:0,
          is_type:'0',
          coin:0,
          money:0,
          remark:"",
          password:'',
          parent_name:'',
          parent_id:''
        },
        formData1:{},
        title1:'',
        visible1:false,

        formData2:{},
        title2:'',
        visible2:false,


        rules: {
          title: [
            { required: true, message: "请输入标题", trigger: "blur" },
            { min: 2, max: 30, message: "请控制在2-30个字符", trigger: "blur" },
          ]
        },
        curShop:'',
        employee_id:'',
        name_cn:'',

        keywords:'',
        fileList:[],
        unitList:[],
        skuList:[],
        mouldList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {
      ///this.getList();
      //this.getRankList();
      this.batch=moment().format("YYMMDD");
    },
    methods:{
      closeForm1(){
        this.title1="";
        this.visible1=false;
        this.form.parent_id=this.formData1.parent_id;
        this.form.parent_name=this.formData1.parent_name;
      },
      showUser(){
       this.title1='选择用户';
       this.visible1=true;
      },
      getRankList(){
        // let _this=this;
        // const param = {
        //   access_token:sessionStorage.getItem('token'),
        //   company_id:sessionStorage.getItem('company_id')
        // }
        // this.$axios.userRankList(param).then(res=>{
        //   if(res.code == 200){
        //     _this.rankList = res.data
        //   }
        // }).catch(error=>{
        //   console.log(error);
        // })
      },
      RoleNameList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:this.formData.shop_id
        }
        this.$axios.getShopRoleList(param).then(res=>{
          if(res.code == 200){
            this.roleNameData = res.data
          }
        })
      },
      // 关闭
      handleClose() {
        this.closeForm();
      },
      onSubmit() {
            const param = {
              id:this.id,
              sn: this.form.sn,
              user_name: this.form.user_name,
              shop_id: this.form.shop_id,
              // mobile: this.form.mobile,
              // sex: this.form.sex,
              //company_department_id: this.form.company_department_id,
              role_id: this.form.role_id,
              //address: this.form.address,
              // education: this.form.education,
              status: this.form.status,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
              password:hexMD5(this.form.pass),
              repassword:hexMD5(this.form.repass),
            }
            this.$axios.shopUserSave(param).then(res =>{
              if(res.code == 200){
                this.$message.success("保存成功！");
                 this.closeForm();
                 console.log('rest')
              }else{
                this.$message.error(res.msg);
              }
            })


      },
      // 前置提交
      // onSubmit() {
      //   const param = {
      //     company_id:sessionStorage.getItem('company_id'),
      //     access_token:sessionStorage.getItem('token'),
      //     user_id: this.formData.user_id,
      //     user_rank: this.form.user_rank,
      //     realname: this.form.realname,
      //     nickname: this.form.nickname,
      //     user_name: this.form.user_name,
      //     parent_id: this.form.parent_id,
      //     password: this.form.password,
      //     operator_id: sessionStorage.getItem('employee_id'),
      //   }
      //  this.$axios.mallUserSave(param).then(res=>{
      //     if(res.code == 200){
      //       this.$message({
      //         message:'保存成功！',
      //         type:'success',
      //         offset:225,
      //         duration:4000,
      //         onClose:()=>{
      //
      //         }
      //       });
      //     }
      //   }).catch(error=>{
      //     console.log(error);
      //   })
      //   this.closeForm();
      //
      // },
      submit() {
        // let param={
        //   appid:this.formData.appid,
        //   private_key:this.formData.private_key,
        //   public_key:this.formData.public_key,
        // }

      },
      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        this.localVisible=val;
        if (val) {

          this.shopInfo = this.formData.item;

          this.form.shop_id=this.formData.shop_id;
          this.form.role_id=this.formData.role_id;
          this.form.shop_name=this.formData.shop_name;
         // this.form.nickname=this.formData.nickname;
          // this.form.user_rank=this.formData.user_rank.rank_id;
          //
          // this.form.user_name=this.formData.user_name;
          // this.form.parent_id=this.formData.parent_id;
          // this.form.parent_name=this.formData.parent_name;
          this.RoleNameList();
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
    computed: {

    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
